import React from 'react'
import { LoungeScheduledGamesScreen } from '@/screens/lounges/LoungeScheduledGamesScreen'

export default function LoungeScheduledGamesRoute() {
  return <LoungeScheduledGamesScreen />
}
